<template>
    <div class="min-h-screen flex">
        <div
            key="no-data"
            class="w-full flex flex-col items-center justify-center"
        >
            <IconNoData class="h-56 w-56 text-gray-500" />
            <p class="text-gray-500 max-w-lg text-center">
                {{ $t('account.accountNoData') }}
            </p>
            <span
                class="hover:bg-primary-100 hover:text-primary hover:border-primary py-1 mt-2 px-4 cursor-pointer text-gray-500 flex items-center border-2 rounded"
                @click="createNewDashboard()"
            >
                <IconPlus class="w-3 mr-1 mb-0-5" />
                <span>{{ $t('common.newDashboard') }}</span>
            </span>
        </div>
    </div>
</template>
<script>
export default {
    methods: {
        createNewDashboard () {
            this.$router.push('dashboard-creation')
        },
    },
}
</script>
